import React from 'react';
export function SocialProof() {
  return <section className="w-full bg-navy-light py-16 md:py-24 px-4" data-id="element-309">
      <div className="max-w-4xl mx-auto" data-id="element-310">
        <p className="text-cyan text-sm uppercase tracking-widest text-center mb-4" data-id="element-311">
          RESULTADOS
        </p>

        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-312">
          Resultados del protocolo:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-313">
          {/* Testimonial 1 */}
          <div className="bg-navy rounded-xl border-l-4 border-cyan p-6" data-id="element-314">
            <p className="text-white font-bold mb-4" data-id="element-315">
              👤 Marco, 38 años — Ingeniero
            </p>

            <div className="mb-4" data-id="element-316">
              <p className="text-gray-400 text-sm uppercase mb-2" data-id="element-317">ANTES:</p>
              <p className="text-gray-300 italic" data-id="element-318">
                "Dormía 7 horas pero a las 2pm era un zombie. Mandíbula tensa,
                mente que no para."
              </p>
            </div>

            <p className="text-cyan text-sm mb-4" data-id="element-319">PATRÓN: #1 Mente acelerada</p>

            <div className="bg-navy-light rounded-lg p-4" data-id="element-320">
              <p className="text-white font-bold text-sm mb-3" data-id="element-321">
                RESULTADOS DÍA 14:
              </p>
              <div className="space-y-2 font-mono text-sm" data-id="element-322">
                <p data-id="element-323">
                  <span className="text-gray-400" data-id="element-324">Latencia:</span>{' '}
                  <span className="text-alert" data-id="element-325">45 min</span>{' '}
                  <span className="text-gray-500" data-id="element-326">→</span>{' '}
                  <span className="text-cta" data-id="element-327">18 min</span>
                </p>
                <p data-id="element-328">
                  <span className="text-gray-400" data-id="element-329">Descanso:</span>{' '}
                  <span className="text-alert" data-id="element-330">3/10</span>{' '}
                  <span className="text-gray-500" data-id="element-331">→</span>{' '}
                  <span className="text-cta" data-id="element-332">7/10</span>
                </p>
                <p data-id="element-333">
                  <span className="text-gray-400" data-id="element-334">Energía 2pm:</span>{' '}
                  <span className="text-alert" data-id="element-335">2/10</span>{' '}
                  <span className="text-gray-500" data-id="element-336">→</span>{' '}
                  <span className="text-cta" data-id="element-337">6/10</span>
                </p>
              </div>
            </div>

            <p className="text-gray-400 text-sm mt-4" data-id="element-338">
              Sin pastillas. Sin apps.
            </p>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-navy rounded-xl border-l-4 border-cyan p-6" data-id="element-339">
            <p className="text-white font-bold mb-4" data-id="element-340">
              👤 Daniela, 41 años — Mamá + trabajo remoto
            </p>

            <div className="mb-4" data-id="element-341">
              <p className="text-gray-400 text-sm uppercase mb-2" data-id="element-342">ANTES:</p>
              <p className="text-gray-300 italic" data-id="element-343">
                "Me despertaba a las 3am con el corazón acelerado. Lista mental
                de todo lo pendiente."
              </p>
            </div>

            <p className="text-cyan text-sm mb-4" data-id="element-344">
              PATRÓN: #2 Despertares nocturnos
            </p>

            <div className="bg-navy-light rounded-lg p-4" data-id="element-345">
              <p className="text-white font-bold text-sm mb-3" data-id="element-346">
                RESULTADOS DÍA 14:
              </p>
              <div className="space-y-2 font-mono text-sm" data-id="element-347">
                <p data-id="element-348">
                  <span className="text-gray-400" data-id="element-349">Despertares:</span>{' '}
                  <span className="text-alert" data-id="element-350">4/noche</span>{' '}
                  <span className="text-gray-500" data-id="element-351">→</span>{' '}
                  <span className="text-cta" data-id="element-352">1/noche</span>
                </p>
                <p data-id="element-353">
                  <span className="text-gray-400" data-id="element-354">Descanso:</span>{' '}
                  <span className="text-alert" data-id="element-355">2/10</span>{' '}
                  <span className="text-gray-500" data-id="element-356">→</span>{' '}
                  <span className="text-cta" data-id="element-357">6/10</span>
                </p>
                <p data-id="element-358">
                  <span className="text-gray-400" data-id="element-359">Energía 2pm:</span>{' '}
                  <span className="text-alert" data-id="element-360">2/10</span>{' '}
                  <span className="text-gray-500" data-id="element-361">→</span>{' '}
                  <span className="text-cta" data-id="element-362">5/10</span>
                </p>
              </div>
            </div>

            <p className="text-cta text-sm mt-4 italic" data-id="element-363">
              "La semana 2 cambió todo."
            </p>
          </div>
        </div>
      </div>
    </section>;
}